import { Duration } from "date-fns";

// eslint-disable-next-line @tseslint/typedef
export const PROJECT_CUSTOMER_DOCUMENT_SPECIAL_DURATIONS = {
  projectEnd: "project_end",
  unlimited: "unlimited"
} as const;
export type ProjectCustomerDocumentSpecialDuration = typeof PROJECT_CUSTOMER_DOCUMENT_SPECIAL_DURATIONS[keyof typeof PROJECT_CUSTOMER_DOCUMENT_SPECIAL_DURATIONS];

type ProjectCustomerDocumentDurationUnitDto = "year" | "month" | "week" | "day" | ProjectCustomerDocumentSpecialDuration;

export type ProjectCustomerDocumentDuration = Duration | ProjectCustomerDocumentSpecialDuration;
export interface CustomerDocumentDto {
  readonly number: string;
  name?: string | undefined;
  validityDuration?: number;
  validityUnit_name?: ProjectCustomerDocumentDurationUnitDto;
  defaultDescription?: string | undefined;
}
export interface ProjectCustomerDocumentDto {
  readonly type_number: string;
  type_name?: string | undefined;
  type_defaultDescription?: string | undefined;
  type_validityDuration?: number;
  type_validityUnit_name?: ProjectCustomerDocumentDurationUnitDto;
}
export interface ProjectCustomerDocument {
  readonly id: string;
  name?: string;
  duration?: ProjectCustomerDocumentDuration | undefined;
  description?: string;
}
export type ProjectCustomerDocumentId = Pick<ProjectCustomerDocument, "id">;

function parseToProjectCustomerDocumentDuration (unit: ProjectCustomerDocumentDurationUnitDto, duration?: number): ProjectCustomerDocumentDuration {
  switch (unit) {
    case "year": {
      return {
        years: duration ?? 0
      };
    }

    case "month": {
      return {
        months: duration ?? 0
      };
    }

    case "week": {
      return {
        weeks: duration ?? 0
      };
    }

    case "day": {
      return {
        days: duration ?? 0
      };
    }

    default: {
      return unit;
    }
  }
}

function isProjectCustomerDocumentDto (value: unknown): value is ProjectCustomerDocumentDto {
  if (!value || typeof value !== "object") return false;

  const maybeDocument: ProjectCustomerDocumentDto = value as ProjectCustomerDocumentDto;

  if (maybeDocument.type_number) return true;

  return false;
}

export function parseToProjectCustomerDocument (value: CustomerDocumentDto | ProjectCustomerDocumentDto): ProjectCustomerDocument {
  if (isProjectCustomerDocumentDto(value)) {
    return {
      name: value.type_name ?? "",
      id: value.type_number,
      description: value.type_defaultDescription ?? "",
      duration: value.type_validityUnit_name
        ? parseToProjectCustomerDocumentDuration(value.type_validityUnit_name, value.type_validityDuration)
        : undefined
    };
  }

  return {
    name: value.name ?? "",
    description: value.defaultDescription ?? "",
    duration: value.validityUnit_name
      ? parseToProjectCustomerDocumentDuration(value.validityUnit_name, value.validityDuration)
      : undefined,
    id: value.number
  };
}
export function parseToCustomerDocumentDto (value: ProjectCustomerDocument): CustomerDocumentDto {
  return {
    name: value.name,
    number: value.id,
    defaultDescription: value.description
  };
}
export function parseToProjectCustomerDocumentDto (value: ProjectCustomerDocument): ProjectCustomerDocumentDto {
  return {
    type_name: value.name,
    type_number: value.id,
    type_defaultDescription: value.description
  };
}
